export default "__VITE_ASSET__BYM5REsL__"